import { Heading } from "@chakra-ui/react";
import { Link } from "gatsby";
import React from "react";
import ReactMarkdown from "react-markdown";
import { ListItem } from "../List/components/ListItem";
import { rendererStyles } from "./content-renderer.module.scss";

export interface ContentRendererProps {
  className?: string;
  source: string;
  emptyUl?: boolean;
}

const LinkRenderer = (props: any) => {
  const { href, children } = props;

  if (href.startsWith("http")) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }

  return (
    <Link to={href} className="inline-flex">
      <div className="underline text-primary inline-flex">{children}</div>
    </Link>
  );
};

export const ContentRenderer = (props: ContentRendererProps) => {
  const { className = "", source, emptyUl = false } = props;
  return (
    <div className={`${rendererStyles} ${className}`}>
      <ReactMarkdown
        skipHtml={false}
        children={source}
        // If the url start with either http or https, the image is hosted somewhere else,
        // if hover it starts with / we need to prepend the strapi api url to the url
        transformImageUri={(uri) =>
          uri.startsWith("http") ? uri : `${process.env.GATSBY_API_URL}${uri}`
        }
        components={{
          a: LinkRenderer,
          ol: ({ children }) => {
            return <ol className="space-y-6 my-6">{children}</ol>;
          },
          ul: ({ children }) => {
            return <ul className="space-y-6 my-6 ">{children}</ul>;
          },
          h3: ({ children }) => {
            return (
              <Heading mb="5" size="md">
                {children}
              </Heading>
            );
          },
          hr: ({ children }) => {
            return (
              <div className="pt-4 flex w-full">
                {children}
                {"‎‎"}
              </div>
            );
          },
          p: ({ children }) => {
            return <p className="">{children}</p>;
          },
          strong: ({ children }) => {
            return <b className="text-primary">{children}</b>;
          },
          li: ({ children, ordered, index }) => {
            let type = ordered ? "numbered" : "check";

            if (emptyUl) type = "empty";

            return <ListItem type={type} label={children} number={index + 1} />;
          },
        }}
      />
    </div>
  );
};
